import CloudIntegrationView from '@/views/Cloud/setting.vue';
import AllConnections from '@/components/Cloud/Settings/setting.vue';
import AWSConnections from '@/views/Cloud/AwsConnections.vue';
import AwsServicesView from '@/views/Cloud/aws/services.vue';

export const integrations = [
  {
    path: 'integrations',
    name: 'integrations',
    component: CloudIntegrationView,
    redirect: {
      name: 'integrationsComp',
    },
    children: [
      {
        path: '',
        name: 'integrationsComp',
        component: AllConnections,
      },
      {
        path: 'aws',
        name: 'awsSubscriptions',
        component: AWSConnections,
      },
      {
        path: 'aws/:subscriptionId',
        name: 'integrationAwsServices',
        component: AwsServicesView,
      },
    ],
  },
];
